/* Regista mobile cart/toast hard fix
   Fixes mobile toast close and checkout navigation when drawer overlays are open.
*/
(function () {
  "use strict";

  var lastActionAt = 0;

  function recentlyHandled() {
    var now = Date.now();
    if (now - lastActionAt < 450) return true;
    lastActionAt = now;
    return false;
  }

  function closeToast() {
    var toast = document.querySelector("[data-regista-cart-toast], .regista-cart-toast");
    if (!toast) return;
    toast.classList.remove("is-visible");
    toast.setAttribute("aria-hidden", "true");
    toast.style.pointerEvents = "none";
  }

  function goToCheckout(link) {
    window.location.href = link && link.href ? link.href : "/checkout";
  }

  function closeCartDrawer() {
    var drawer = document.querySelector("#cart-drawer, cart-drawer");
    if (!drawer) return false;

    try {
      if (typeof drawer.hide === "function") {
        drawer.hide();
        return true;
      }
    } catch (error) {}

    drawer.removeAttribute("open");
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("lock");
    document.body.classList.remove("lock");
    return true;
  }

  function handleAction(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toastClose = target.closest(".regista-cart-toast__close");
    if (toastClose) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      closeToast();
      return;
    }

    var toastCheckout = target.closest(".regista-cart-toast__cart-link");
    if (toastCheckout) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      if (recentlyHandled()) return;
      goToCheckout(toastCheckout);
      return;
    }

    var drawerClose = target.closest("[data-regista-force-close], .regista-drawer-close");
    if (drawerClose) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      closeCartDrawer();
    }
  }

  ["click", "touchend", "pointerup"].forEach(function (eventName) {
    document.addEventListener(eventName, handleAction, true);
  });

  // Keep toast usable even after the original script disables pointer events when hidden
  document.addEventListener("cart:change", function () {
    window.setTimeout(function () {
      var toast = document.querySelector("[data-regista-cart-toast], .regista-cart-toast");
      if (!toast) return;

      var link = toast.querySelector(".regista-cart-toast__cart-link");
      if (link && !link.textContent.trim()) link.textContent = "לקופה";

      toast.style.pointerEvents = "";
      toast.removeAttribute("aria-hidden");
    }, 120);
  }, true);
})();
